import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store';

export interface ICurrentUserResponse {
    statusCode: number | string
    data: any
}

export interface CurrentUserState {
    //TODO: FP-10887 - Remove any use ICurrentUserResponse
    currentUserData: any | null;
    userToken?: string | null;
}

const initialState: CurrentUserState = {
    currentUserData: null,
};

const userSlice = createSlice({
    name: 'userdata',
    initialState,
    reducers: {
        //TODO: FP-10887 - Remove any, use ICurrentUserResponse
        setCurrentUserData: (state, action: PayloadAction<any>) => {
            state.currentUserData = action.payload.data;
        },
        setUserToken: (state, action: PayloadAction<string>) => {
            state.userToken = action.payload;
        }
    },
});

export const currentUserAPI = createApi({
    reducerPath: "me",
    baseQuery: getBaseQuery( getBaseUrl() + "API/v3" ),
    endpoints: (build) => ({
        //TODO: FP-10887 - Remove any, use ICurrentUserResponse
        getUserData: build.query<any, void>({
            query: () => "/Account/me",
        }),
        updateUserData: build.mutation<any, any>({
            query: (body) => ({
                url: "/Account/me", // Assuming the user settings are updated here
                method: "PUT", // Equivalent to your old Backbone `PUT`
                body,
            }),
        }),
    }),
});
export const getUserToken = (state: RootState) => state.userdata?.userToken || '';
export const { setCurrentUserData, setUserToken } = userSlice.actions;
export default userSlice.reducer;
export const { useGetUserDataQuery, useUpdateUserDataMutation } = currentUserAPI;